export default function BmgMedPlans({ onGoToRegister }) {
    const coberturas = [
        { nome: "Telemedicina grátis e ilimitada com clínico geral", individual: "✅", plus: "✅" },
        { nome: "Telemedicina com especialistas", individual: "❌", plus: "6 utilizações/ano" },
        { nome: "Consulta presencial com médico", individual: "R$ 50", plus: "R$ 50" },
        { nome: "Descontos em exames", individual: "✅", plus: "✅" },
        { nome: "Descontos a partir de 15% em remédios em mais de 6 mil farmácias", individual: "✅", plus: "✅" },
        { nome: "Check-up médico anual", individual: "❌", plus: "✅" },
        { nome: "Sorteios mensais*", individual: "R$ 5 mil", plus: "R$ 10 mil" },
        { nome: "Cobertura de morte acidental", individual: "R$ 1 mil", plus: "R$ 1 mil" },
    ];

    return (
        <section id="BmgMedPlans" className="py-10 bg-white">
            <div className="max-w-6xl mx-auto text-center px-4">
                {/* Título */}
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800">Planos Bmg Med</h2>
                <p className="text-gray-600 mt-2">
                    Compare as vantagens e escolha o plano ideal para você.
                </p>
            </div>

            {/* Grid responsivo */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto px-4">

                {/* 📌 Card Plano Individual */}
                <div className="bg-gray-50 border rounded-xl shadow-md p-6 flex flex-col">
                    <div className="text-center mb-4">
                        <h3 className="text-xl font-bold text-gray-800">Plano Individual</h3>
                        <p className="text-3xl font-bold text-gray-900 mt-1">R$ 21,90 <span className="text-lg font-normal">/ mês</span></p>
                    </div>
                    <ul className="space-y-3 flex-1">
                        {coberturas.map((item, i) => (
                            <li key={i} className="flex justify-between items-center border-b pb-2 text-gray-700">
                                <span className="text-sm font-medium">{item.nome}</span>
                                <span className="text-sm font-semibold">{item.individual}</span>
                            </li>
                        ))}
                    </ul>
                    <button onClick={onGoToRegister} className="mt-6 bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition">
                        Assinar Plano Individual
                    </button>
                </div>

                {/* 📌 Card Plano Plus */}
                <div className="bg-orange-50 border border-orange-300 rounded-xl shadow-md p-6 flex flex-col relative">
                    {/* selo */}
                    <span className="absolute -top-3 right-3 bg-orange-600 text-white text-xs px-3 py-1 rounded-md">
                        Os clientes preferem este
                    </span>

                    <div className="text-center mb-4">
                        <h3 className="text-xl font-bold text-orange-700">Plano Plus</h3>
                        <p className="text-3xl font-bold text-orange-700 mt-1">R$ 29,90 <span className="text-lg font-normal">/ mês</span></p>
                    </div>
                    <ul className="space-y-3 flex-1">
                        {coberturas.map((item, i) => (
                            <li key={i} className="flex justify-between items-center border-b pb-2 text-gray-700">
                                <span className="text-sm font-medium">{item.nome}</span>
                                <span className="text-sm font-semibold">{item.plus}</span>
                            </li>
                        ))}
                    </ul>
                    <button onClick={onGoToRegister} className="mt-6 bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition">
                        Assinar Plano Plus
                    </button>
                </div>
            </div>

            <p className="text-xs text-gray-500 mt-4 text-center">
                *Valores brutos, sem incidência de Imposto de Renda
            </p>
        </section>
    );
}
